import Icon from '../components/Icon.vue'

Icon.register({"quidditch":{"width":640,"height":512,"paths":[{"d":"M256.5 216.8L343.2 326S326.6 428.4 266.6 476.1C206.7 523.8 0 510.2 0 510.2S3.8 487.1 11 454.8L105.6 342.6C109.6 337.9 104.7 331 99 333.1L38.6 355.2C53 313.5 71.3 275.2 93.2 257.7 153.1 209.9 256.5 216.8 256.5 216.8zM494.5 351.8C450.5 351.8 414.7 387.6 414.7 431.7 414.7 475.8 450.4 511.6 494.5 511.6 538.6 511.6 574.3 475.8 574.3 431.7 574.3 387.5 538.5 351.8 494.5 351.8zM636.5 31L616.7 6C611.2-0.9 601.2-2 594.3 3.4L361.8 181.3 327.7 138.3C322.6 131.9 312.6 133.1 309.1 140.5L283.8 195.1 370.5 304.3 429.3 291.9C437.3 290.2 440.7 280.7 435.6 274.3L401.5 231.4 634 53.5C640.9 48 642 37.9 636.5 31z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/quidditch.js
// module id = null
// module chunks = 